export enum CharityManagementScreenState {
  SortAndView = 1,
  MoveCharityPledgesBetweenCharities = 2
}
